import React from 'react';
import { helperMargin, Tabs as UITabs } from '@utex/ui-kit';
import { TabSchema } from '../../../../hooks/useTabs/mapping';
import { CardInstrumentId, subSchema } from '../../consts';

interface Props {
  activeTab: CardInstrumentId;
  setActiveTab: (id: CardInstrumentId) => void;
  available: TabSchema<CardInstrumentId>[];
}

export const Tabs: React.FC<Props> = ({ available, activeTab, setActiveTab }) => (
  <UITabs
    size={{ tablesktop: 'L', phonablet: 'M' }}
    alignItems="flex-end"
    css={helperMargin({ bottom: 20 })}
  >
    {available.map(({ id }) => {
      const { Tab } = subSchema[id];
      return <Tab isActive={activeTab === id} onClick={() => setActiveTab(id)} />;
    })}
  </UITabs>
);
